import React from 'react';
import css from './LogoSharetribe.module.scss';
import classNames from 'classnames';
import Link from '@components/Link/Link';

const LogoSharetribe = ({ mode = 'dark' }) => {
  const logoClassName = classNames({
    [css.logoColorDark]: mode === 'dark',
    [css.logoColorLight]: mode === 'light',
    [css.logoColorCyan]: mode === 'cyan',
  });

  return (
    <Link to="/" className={css.logo} aria-label="Link to Sharetribe's homepage">
      <svg width="159" height="28" viewBox="0 0 159 28" xmlns="http://www.w3.org/2000/svg">
        <g fillRule="nonzero" fill="none">
          <path
            className={logoClassName}
            d="M41.7 20.2c-1 .7-2.3 1.1-4 1.1-2 0-4.1-.6-5.6-2l1.6-2.5c1.1.9 2.8 1.6 3.9 1.6s1.8-.3 1.8-1.1c0-.9-1.9-1.3-2.4-1.4-.5-.1-1.3-.3-1.9-.6-.6-.3-2.2-1.1-2.2-3.4 0-2.6 2.2-4.1 5-4.1s4.3 1 5 1.6l-1.4 2.5c-.7-.6-2.2-1.3-3.3-1.3-1 0-1.6.3-1.6 1s1 1 1.9 1.3c.9.3 1.3.4 1.9.6.6.2 1.3.6 1.7 1 .4.4 1.1 1.3 1.1 2.7.1 1.2-.5 2.3-1.5 3zM58.2 21.1h-4.3v-6.9c0-1.6-.2-3-2-3s-2.4 1.5-2.4 3.4v6.5h-4.3V2.7h4.3v7.1c.7-1.2 1.9-2.1 3.9-2.1 3.8 0 4.8 2.4 4.8 5.6v7.8zM72.8 21.1h-4.1l-.1-1.4c-.6.6-1.6 1.7-3.8 1.7-2.3 0-4.8-1.3-4.8-4.2 0-2.9 2.7-3.9 5.1-4l3.3-.1v-.3c0-1.4-1-2.1-2.7-2.1-1.7 0-3.4.7-4 1.2l-1-2.9c1.1-.6 3.2-1.3 5.6-1.3 2.5 0 3.9.6 4.9 1.5 1 1 1.6 2.2 1.6 4.5v7.4zm-4.2-5.8l-2.1.1c-1.3.1-2.1.6-2.1 1.6s.8 1.6 2 1.6c1.1 0 1.9-.7 2.2-1.2v-2.1zM83.9 11.8h-.2c-.2-.1-.8-.3-1.5-.3-1 0-1.7.5-2 1-.3.5-.7 1.3-.7 2.8v5.8h-4.3V7.9h4.3v1.9h.1c.7-1.4 1.8-2.1 3.3-2.1.9 0 1.3.2 1.3.2l-.3 3.9zM98.5 15.5h-9.4c.2 1.9 1.6 2.8 3.4 2.8 1.7 0 3.2-.7 4-1.3l1.7 2.2c-.4.3-2.2 2.1-6.3 2.1s-7-2.5-7-6.9 3.2-6.8 7.1-6.8c3.9 0 6.6 2.6 6.6 6.4-.1.8-.1 1.5-.1 1.5zm-3.9-2.4c0-1.2-.9-2.6-2.7-2.6-1.8 0-2.7 1.4-2.7 2.6h5.4zM108.7 11.2h-2.9v4.7c0 1.1.2 1.4.4 1.6.2.2.5.3 1 .3.7 0 1.3-.2 1.3-.2l.2 3.3c-.3.1-1.5.4-3 .4s-2.5-.5-3.2-1.2c-.7-.8-.9-1.9-.9-3.9v-5.1h-1.9V7.9h1.9V4.4h4.3V8h2.9v3.2h-.1zM119.6 11.8h-.2c-.2-.1-.8-.3-1.5-.3-1 0-1.7.5-2 1-.3.5-.7 1.3-.7 2.8v5.8H111V7.9h4.3v1.9h.1c.7-1.4 1.8-2.1 3.3-2.1.9 0 1.3.2 1.3.2l-.4 3.9zM124 6.4c-1.4 0-2.4-.9-2.4-2.2 0-1.3 1-2.2 2.4-2.2s2.4.9 2.4 2.2c0 1.3-1 2.2-2.4 2.2z"
            fill="#ED4F2E"
          />
          <path className={logoClassName} fill="#F15B40" d="M121.9 7.9h4.3v13.2h-4.3z" />
          <path
            className={logoClassName}
            d="M136.9 21.4c-1.8 0-3.4-.6-4.4-2v1.7h-4.1V2.7h4.3v4.4c0 1.2-.1 2.4-.1 2.4h.1c.6-.8 1.9-1.8 4.1-1.8 3.8 0 6.2 3 6.2 6.8s-2.3 6.9-6.1 6.9zM135.7 11c-1.8 0-3.1 1.4-3.1 3.4s1.3 3.4 3.1 3.4 3.1-1.4 3.1-3.4-1.2-3.4-3.1-3.4zM158.2 15.5h-9.4c.2 1.9 1.6 2.8 3.4 2.8 1.7 0 3.2-.7 4-1.3l1.7 2.2c-.4.3-2.2 2.1-6.3 2.1s-7-2.5-7-6.9 3.2-6.8 7.1-6.8c3.9 0 6.6 2.6 6.6 6.4 0 .8-.1 1.5-.1 1.5zm-3.9-2.4c0-1.2-.9-2.6-2.7-2.6-1.8 0-2.7 1.4-2.7 2.6h5.4z"
            fill="#ED4F2E"
          />
          <g fill="#ED4F2E">
            <path
              className={logoClassName}
              d="M23.4 7.4L12.5 1.1c-.3-.2-.7-.2-1 0 0 0-.9.5-.9.6-1.2.7-1.7 2.1-.1 2.9 1.9 1 4 2.1 4 2.1C17.2 8.1 17 9 17 10.6v1.1l-6.5-3.5c-.5-.2-.8 0-.8.5v1.6c0 .5.4 1.2.8 1.4l2.7 1.5c1.4.8 3.8 1.7 3.8 3.3v8.7l6.4-3.5c.3-.2.5-.5.5-.8V8.2c0-.3-.2-.6-.5-.8z"
            />
            <path
              className={logoClassName}
              d="M.4 21.5l10.9 6.3c.3.2.7.2 1 0 0 0 .9-.5.9-.6 1.2-.7 1.7-2.1.1-2.9-1.9-1-4-2.1-4-2.1-2.7-1.3-2.5-2.3-2.5-3.9v-1.1l6.5 3.5c.5.3.8 0 .8-.5v-1.6c0-.5-.4-1.2-.8-1.4l-2.7-1.5c-1.4-.8-3.8-1.7-3.8-3.3V3.7L.4 7.2c-.2.2-.4.6-.4.9v12.6c0 .3.2.6.4.8z"
            />
          </g>
        </g>
      </svg>
    </Link>
  );
};

export default LogoSharetribe;
